module.exports = __webpack_public_path__ + "img/IMG_1539_L_WoodMatted_MockedUp.aa0a6f52.jpg";